import React, { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { deleteCrossClientLandingExecution, selectCrossClientLandingQueuedExecutions } from '../../../../store/crossClient/crossClientLanding'
import { type CrossClientQueryExecution } from '../../../../models/CrossClient'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { CrossClientRunningExecutionsPoller } from '../RunningExecutions/CrossClientRunningExecutionsPoller'
import { CrossClientListPoller } from '../RunningExecutions/CrossClientListPoller'
import { TrackEvent, useTracking } from '../../../../apps/professional-app/fa/common/tracking'
import { useDeleteCrossClientQueryExecutionMutation } from '../../../../store/crossClient/crossClient'
import { CrossClientDeleteModal } from '../../Modal/CrossClientDeleteModal'
import { CrossClientQueuedElement } from './CrossClientQueuedElement'

export const CrossClientLandingQueued: React.FC = () => {
  const dispatch = useAppDispatch()

  const { tracked } = useTracking()

  const accountId = useAppSelector(selectAccountId)

  const queuedExecutions = useAppSelector(selectCrossClientLandingQueuedExecutions)

  const [triggerDeleteCrossClientExecution, { isLoading: deleteLoading }] = useDeleteCrossClientQueryExecutionMutation()

  const [deletingExecution, setDeletingExecution] = useState<CrossClientQueryExecution | null>(null)

  const handleClickDeleteExecution = (execution: CrossClientQueryExecution) => {
    setDeletingExecution(execution)
  }

  const handleDeleteExecution = tracked(
    async () => {
      if (!deletingExecution) {
        return
      }
      try {
        await triggerDeleteCrossClientExecution({ accountId, executionId: deletingExecution.id }).unwrap()
        dispatch(deleteCrossClientLandingExecution(deletingExecution.id))
      } catch (e) {
        console.error(e)
      }
      setDeletingExecution(null)
    },
    {
      eventName: TrackEvent.X_CLIENT_QUERY_DELETED,
      eventDetails: { executionId: deletingExecution?.id },
    },
    { condition: !!deletingExecution },
  )

  const handleCancelDelete = () => {
    setDeletingExecution(null)
  }

  return (
    <>
      {deletingExecution ? (
        <CrossClientDeleteModal show={!!deletingExecution} loading={deleteLoading} onDelete={handleDeleteExecution} onCancel={handleCancelDelete} />
      ) : null}
      <CrossClientRunningExecutionsPoller />
      <CrossClientListPoller />
      <div className='d-flex flex-column gap-3 align-items-center'>
        {queuedExecutions.length ? (
          queuedExecutions.map((execution) => <CrossClientQueuedElement key={execution.id} execution={execution} onDelete={handleClickDeleteExecution} />)
        ) : (
          <div className='paragraph-small zocks-text-gray-600'>No queued queries</div>
        )}
      </div>
    </>
  )
}
